import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function ArrowNextIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <g fill="none">
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          d="M3.00003 12.1713H20.9402M13.7749 5L21 12.1952L13.7749 19.3904"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
